import { Routes, Route } from 'react-router-dom'
import { Layout } from '@/components/layout/Layout'
import Home from '@/pages/Home'
import Dashboard from '@/pages/Dashboard'
import Placeholder from '@/pages/Placeholder'
import NotFound from '@/pages/NotFound'
import Affiliate from '@/pages/Affiliate'
import VipClub from '@/pages/VipClub'
import P2pLegends from '@/pages/P2pLegends'
import P2pMarketDetail from '@/pages/P2pMarketDetail'
import Originals from '@/pages/Originals'
import Sportsbook from '@/pages/Sportsbook'
import Casino from '@/pages/Casino'
import CasinoPlay from '@/pages/CasinoPlay'
import OriginalPlay from '@/pages/OriginalPlay'
import Staking from './pages/Staking'
import Profile from './pages/Profile'

export function AppRoutes() {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route path='/' element={<Home />} />
				<Route path='/dashboard' element={<Dashboard />} />
				<Route path='/sportsbook' element={<Sportsbook />} />
				<Route path='/casino' element={<Casino />} />
				<Route path='/casino/play/:casinoId' element={<CasinoPlay />} />
				<Route path='/becy-originals' element={<Originals />} />
				<Route path='/original/play/:gameId' element={<OriginalPlay />} />
				<Route path='/staking' element={<Staking />} />
				<Route path='/affiliate' element={<Affiliate />} />
				<Route path='/p2p-legends' element={<P2pLegends />} />
				<Route path='/p2p-legends/:marketId' element={<P2pMarketDetail />} />
				<Route path='/vip-club' element={<VipClub />} />
				<Route path='/profile' element={<Profile />} />
				<Route
					path='/buy-sell'
					element={<Placeholder title='BECY Buy / Sell' description="Buy and sell BECY tokens here. Keep prompting to fill in this page's content." />}
				/>
			</Route>
			{/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
			<Route path='*' element={<NotFound />} />
		</Routes>
	)
}
